import { FormEvent, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthPageShell } from "../components/AuthPageShell";
import { PasswordInput } from "../components/PasswordInput";
import { apiFetch, ApiError } from "../api/client";
import { completeAuthRedirect } from "../lib/authRedirect";
import { boardAuthMessage } from "../lib/boardAuthMessages";

export function LoginPage() {
  const [params] = useSearchParams();
  const ret = params.get("return") || "/cabinet";
  const [err, setErr] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    // Школьный вход сюда больше не редиректит (он возвращает на /school),
    // но старые ссылки с ?board_auth= ещё ходят по почте и закладкам.
    const msg = boardAuthMessage(params.get("board_auth"));
    if (msg) setErr(msg);
  }, [params]);

  const registerHref = `/register?return=${encodeURIComponent(ret)}`;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await apiFetch("/api/v1/auth/login", {
        method: "POST",
        json: { email: email.trim(), password },
      });
      completeAuthRedirect(ret);
    } catch (ex) {
      if (ex instanceof ApiError && ex.code === "main_site_only") {
        setErr(
          "Это школьный аккаунт. Вход по email и паролю для него закрыт — войдите через bez-part.ru."
        );
      } else {
        setErr(ex instanceof Error ? ex.message : "Ошибка входа");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthPageShell loginHref={`/login?return=${encodeURIComponent(ret)}`}>
      <div className="wb-card__badge wb-card__badge--accent">Внешний аккаунт</div>
      <h1 className="wb-h2">Вход</h1>
      <p className="wb-card__intro">Войдите по email и паролю аккаунта доски.</p>
      {err ? (
        <p className="wb-alert wb-alert--error" role="alert">
          {err}
        </p>
      ) : null}
      {/* method="post" и name у полей — не для отправки (её перехватывает
          onSubmit), а для менеджера паролей: по ним браузер понимает, что
          это форма входа, и предлагает сохранить и подставить пароль. */}
      <form className="wb-form-stack" method="post" onSubmit={onSubmit}>
        <div className="wb-form-field">
          <label className="wb-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            name="email"
            className="wb-input"
            type="email"
            required
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={busy}
          />
        </div>
        <div className="wb-form-field">
          <label className="wb-label" htmlFor="password">
            Пароль
          </label>
          <PasswordInput
            id="password"
            name="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
        </div>
        <button className="wb-btn wb-btn--primary wb-btn--lg" type="submit" disabled={busy}>
          {busy ? "Входим…" : "Войти"}
        </button>
      </form>
      <p className="wb-auth-footer">
        Нет аккаунта? <Link to={registerHref}>Зарегистрироваться</Link>
      </p>
    </AuthPageShell>
  );
}
